

export default {
  init() {
    // JavaScript to be fired on pages that use the test listing container
    $(document).ready(function () {
      let testCardTitle = $('.test-listing-container-loop #test-listing-container-filter div.test-listing-container-card .toggle-title');
      let openedCard = $('.test-listing-container-loop #test-listing-container-filter div.test-listing-container-card .toggle-title:not(.closed)');
      let testCardContent = $('.test-listing-container-loop #test-listing-container-filter div.test-listing-container-card .toggle-content');
      let filterTitle = $('.test-listing-container-loop .filter-group .filter-group span.filter-label');
      let filterContent = $('.test-listing-container-loop .filter-group .filter-group ul.uk-subnav');
      let resizeTimer;

      // Test cards - mobile - Allows accordion functionality
      testCardTitle.unbind('click').click( function() {
        // $(this).toggleClass('closed')
        testCardTitle.not($(this)).addClass('closed')
        testCardTitle.not($(this)).next('.toggle-content').slideUp('slow')
        if($(this).hasClass('closed')) {
          $(this).next('.toggle-content').slideDown('fast')
          $(this).removeClass('closed')
        } else {
          $(this).next('.toggle-content').slideUp('slow')
          $(this).addClass('closed')
        }
      })

      // Test cards - collapses content on all test cards if mobile, expands all content if desktop
      function toggleContent() {
        if ($(window).width() > 960) {
          testCardContent.slideDown();
          testCardTitle.removeClass('closed')
        } else {
          testCardContent.slideUp();
          testCardTitle.addClass('closed')
        }
      }

      // Filters - mobile - allows accordion functionality
      // filterTitle.unbind('click').click( function() {
      //   $(this).toggleClass('closed')
      //   $(this).next('div').find('ul').slideToggle('fast')
      // })

      // Filters - collapses all filter groups if mobile, expands all if desktop
      // function toggleFilters() {
      //   if ($(window).width() > 960) {
      //     filterContent.slideDown();
      //     filterTitle.removeClass('closed')
      //   } else {
      //     filterContent.slideUp();
      //     filterTitle.addClass('closed')
      //   }
      // }

      $(window).on('resize', function () {

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {

          toggleContent();
          // toggleFilters();

        }, 100);

      });
      toggleContent()
      // toggleFilters()
    })

  },
  finalize() {
    // JavaScript to be fired on pages that use the test listing container, after the init JS
  },
};
// autoplay: true; autoplay-interval: 0;
// autoplay: true; autoplay-interval: 0;



// WEBPACK FOOTER //
// ./scripts/routes/testListing.js